module.exports = __webpack_public_path__ + "media/HD1080~9.a2b2aafe.mp4";